import AddressForm from "./address_form";
import Route from '../route';

$(function () {

    if (Route === "account-address-book" || Route === "statement") {

        const FormId = "#billingAddressForm";
        const ModalId = "#billingAddressEdit";

        let $modalSpinner = $(".loading", $(ModalId));

        let BillingAddressForm = new AddressForm({
            form_id: FormId,
            read_url: `/billing-address/read`,
        });

        BillingAddressForm.addSubmitListener((response) => {
            if (!response.status) {
                BillingAddressForm.showErrors(response.data);
                BillingAddressForm.turnFormLoadingOff();
            } else {
                window.location.reload();
            }
        });

        // When modal opens, load the data
        $(ModalId).on('shown.bs.modal', function (e) {
            $modalSpinner.removeClass('d-none');
            const button = e.relatedTarget;
            const id = $(button).data("id");
            const $countrySelect = $('#billingAddressForm select[name="country"]');
            BillingAddressForm.setAction("/billing-address/update/" + id);
            BillingAddressForm.hideDropdown('add_lookuplist');

            BillingAddressForm.populateFields(id, (form, data) => {
                const selectedCountry = $('.selectedCountry', form).val();
                $countrySelect.updateVal(selectedCountry);

                $modalSpinner.addClass("d-none");
                $(".form-fields", $(ModalId)).removeClass("d-none");
            });
        }).on('hidden.bs.modal', function () {
            BillingAddressForm.emptyForm();
            $modalSpinner.addClass("d-none");
            $('.form-fields', this).addClass('d-none');
        });

        $(document).on('change', '#billingAddressForm #countrySelect', function () {
            let selectedCountry = $(this).val();
            const selectedCountryName = $('option:selected', $(this)).data('name');

            if (selectedCountry === 'GB') {
                $('#billingAddressForm #findAddressBtn').parent('div').removeClass('d-none'); // Show the button by removing 'd-none' from the parent div
            } else {
                $('#billingAddressForm #findAddressBtn').parent('div').addClass('d-none'); // Hide the button by adding 'd-none' to the parent div
            }

            $('#billingAddressForm .selectedCountryName').val(selectedCountryName);
        });
    }

});
